import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_CLOSED() {
  _init_properties_CloseToken_kt__9ucr41();
  return CLOSED;
}
var CLOSED;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function access$_get_origin__hdh1qz($this) {
  return $this.c4o_1;
}
var CloseTokenClass;
function CloseToken() {
  if (CloseTokenClass === VOID) {
    class $ {
      constructor(origin) {
        this.c4o_1 = origin;
      }
    }
    initMetadataForClass($, 'CloseToken');
    CloseTokenClass = $;
  }
  return CloseTokenClass;
}
var properties_initialized_CloseToken_kt_lgg8zn;
function _init_properties_CloseToken_kt__9ucr41() {
  if (!properties_initialized_CloseToken_kt_lgg8zn) {
    properties_initialized_CloseToken_kt_lgg8zn = true;
    CLOSED = new (CloseToken())(null);
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  access$_get_origin__hdh1qz as access$_get_origin__hdh1qz8t4atr48tdww,
  Companion_instance as Companion_instance2dr5be9lgxo2y,
  get_CLOSED as get_CLOSED3uiwvc5y98ftj,
  CloseToken as CloseToken4utf44psnuyc,
};
//endregion

//# sourceMappingURL=CloseToken.mjs.map
